import { defineMessages } from 'react-intl';

export default defineMessages({
    assistanceVerbiage: {
        id: 'accountManagement.views.further-assistance.If you need further assistance',
        defaultMessage: '&lt;b&gt;If you need further assistance contact us at &lt;a aria-label="contact us by phone at the number 800-640-2920" href="tel:1-800-640-2920"&gt; 800-640-2920&lt;/a&gt; Monday to Friday 7:30 am to 7:30 pm PT and Saturday 8:00 am to 4:30 pm PT.&lt;/b&gt;',
    }
 });
